import React, { useEffect, useState } from "react";
import useHttp from "../../../hooks/use-http";
import Pagination from "../../../components/Pagination";
import { Modal as AntModal } from "antd";
import Modal from "react-modal";
import { toast } from "react-toastify";

const TrainingDetailsList = (props) => {
  const { addForm, update } = props;
  const [data, setData] = useState([]);
  const [itemsPerPage] = useState(10);

  const { sendRequest: getUser } = useHttp();

  const { sendRequest: getDataList } = useHttp();
  const [allData, setAllData] = useState([]);

  const { sendRequest: deleteTrainingDetails } = useHttp();

  const deleteData = (e, trainingDetailId) => {
    e.preventDefault();

    AntModal.confirm({
      title: "Confirm Deletion",
      content: "Are you sure you want to delete this training detail?",
      onOk() {
        const data = {
          trainingDetailId: trainingDetailId,
        };

        deleteTrainingDetails(
          {
            url: "/api/training/",
            body: data,
            method: "DELETE",
          },
          (res) => {
            //  //console.log(res);
            toast.success("Training Details Deleted Successfully");
            FillDetail();
          }
        );
      },
      onCancel() {},
    });
  };

  const FillDetail = () => {
    getDataList(
      {
        url: `/api/training/?orgId=${localStorage.getItem("orgId")}&trainingFor=Procurement`,
      },
      (res) => {
        if (res) {
          setData(res);
          setAllData(res);
        }
      }
      
    );
  };

  useEffect(() => {
    FillDetail();
  }, [getDataList]);

  const [currentPage, setCurrentPage] = useState(1);
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = data.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSearch = (e) => {
      var filetrtext = e.target.value.trim().toLowerCase();
    //console.log(filetrtext);

    var filterdata = allData.filter(
      (item) =>
        item?.docNo?.toLowerCase().includes(filetrtext) ||
        item?.village?.toLowerCase().includes(filetrtext) ||
        item?.subject?.toLowerCase().includes(filetrtext)
    );

   setData(filterdata); 
                                
setCurrentPage(1);
  };

  const customModalStyles = {
    overlay: {
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 1000,
      top: 40,
    },
    content: {
      top: "55%",
      left: "55%",
      transform: "translate(-50%, -50%)",
      maxWidth: "80%",
      width: "700px",
      height: "100%",
      minHeight: "450px",
      overflow: "auto",
    },
  };
  const { sendRequest: getTrainingDetails } = useHttp();
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const openModal = (data) => {
    // //console.log(data);

    const Id = data && data.trainingDetailId;

    getTrainingDetails(
      {
        url: `/api/training/?orgId=${localStorage.getItem(
          "orgId"
        )}&trainingDetailId=${Id}`,
      },
      (res) => {
        //console.log(res);
        setSelectedData(res);
      }
    );

    setSelectedData(data);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <Modal isOpen={isModalOpen} style={customModalStyles}>
        <div className="">
          <h3 className="card-title"> Trainer Details</h3>
          <div className="card-tools text-right">
            <button
              type="button"
              className="btn btn-tool"
              data-card-widget="remove"
              onClick={() => closeModal(false)}
            >
              <i className="fas fa-times" />
            </button>
            <hr />
          </div>
        </div>
        {selectedData && (
          <div>
            <div className="row">
              <div className="col-md-3">
                <label>Date of Training: </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">{selectedData.date} </label>
              </div>

              <div className="col-md-3">
                <label>Doc No: </label>
              </div>

              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.docNo}{" "}
                </label>
              </div>
            </div>
            <div className="row">
              <div className="col-md-3">
                <label> Venue: </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.venue}{" "}
                </label>
              </div>

              <div className="col-md-3">
                <label> Village Name : </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.village}{" "}
                </label>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label> Start Time: </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.startTime}{" "}
                </label>
              </div>

              <div className="col-md-3">
                <label> End Time: </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.endTime}{" "}
                </label>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label> Training Type: </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.trainingType}{" "}
                </label>
              </div>

              <div className="col-md-3">
                <label> Training For: </label>
              </div>
              <div className="col-md-3">
                <label className="form-check-label">
                  {selectedData.trainingFor}{" "}
                </label>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <label> Topic Of Discussion : </label>
              </div>
              <div className="col-md-9">
                <label className="form-check-label">
                  {selectedData.topicOfDiscussion}{" "}
                </label>
              </div>
            </div>

            <div className="row">
              <div className="col-md-3">
                <h5>Subjects List</h5>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Subject</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.subjectsList &&
                    selectedData.subjectsList.map((itm, i) => (
                      <tr key={i} className="cursor-pointer">
                        <td>{i + 1}</td>
                        <td>{itm.subject}</td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3">
                <h5>Focused Crop</h5>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Crop Name</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.focusedCrop &&
                    selectedData.focusedCrop.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.cropName}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3">
                <h5>Executive List</h5>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Executive Code</th>
                    <th>Executive Name</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.executiveDetail &&
                    selectedData.executiveDetail.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.employeeCode}</td>
                          <td>{itm.employeeName}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3">
                <h5>Objective List</h5>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr No.</th>
                    <th>Objective Name</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.objectivesList &&
                    selectedData.objectivesList.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.objectiveName}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>

            <div className="row">
              <div className="col-md-3">
                <h5>Trainers List</h5>
              </div>
            </div>
            <div className="row">
              <table className="table table-bordered text-center">
                <thead>
                  <tr>
                    <th>Sr.No</th>
                    <th>Trainers Name</th>
                    <th>Name Of Organisation</th>
                    <th>Contact Number</th>
                  </tr>
                </thead>
                <tbody>
                  {selectedData.trainersList &&
                    selectedData.trainersList.map((itm, i) => {
                      return (
                        <tr key={i} className="cursor-pointer">
                          <td>{i + 1}</td>
                          <td>{itm.trainerName}</td>
                          <td>{itm.OrganisationName}</td>
                          <td>{itm.trainerContactNo}</td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>
            </div>
          </div>
        )}
        <br/>
      </Modal>

      <div className="content-wrapper">
        <div className="row mx-2">
          <div className="col-6">
            <label className="card-title mx-2 my-3">
              {" "}
              &nbsp; &nbsp;Training Details{" "}
            </label>{" "}
          </div>
          <div className="col-3"> </div>
          <div className="col-3">
            <button
              type="button"
              className="btn  btn-primary mx-2 my-2"
              onClick={() => {
                addForm(true);
                props.update(false);
              }}
            >
              Add Training Detail
            </button>
          </div>
        </div>

        <section className="content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-md-12">
                <div className="card">
                  <div className="card-body">
                    <div className="row">
                      <div className="col-4"> </div>
                      <div className="col-5"> </div>

                      <div className="col-3">
                        {" "}
                        <input
                          type="text"
                          name="q"
                          className="form-control"
                          onKeyUp={(e) => {
                            handleSearch(e);
                          }}
                          placeholder="Search..."
                        />{" "}
                        <br />
                      </div>
                    </div>
                    <div className="row">
                      <table className="table table-bordered text-center">
                        <thead>
                          <tr>
                            <th>Training Date</th>
                            <th>Training Code</th>
                            <th>Village Name</th>
                            <th>Topic Of Discussion</th>
                            <th>Start Time</th>
                            <th>End Time</th>
                            <th>Status</th>
                            <th>Edit</th>
                            <th>Delete</th>
                            <th>View</th>
                          </tr>
                        </thead>
                        <tbody>
                          {currentItems &&
                            currentItems.map((x, i) => (
                              <tr key={i}>
                                <td>{x.date}</td>
                                <td>{x.docNo}</td>
                                <td>{x.village}</td>
                                <td>{x.topicOfDiscussion}</td>
                                <td>{x.startTime}</td>
                                <td>{x.endTime}</td>

                                <td>
                                  {x.status == 1 ? "Active" : "In-Active"}
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => {
                                      props.update(x);
                                      props.addForm(true);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-edit"></i>
                                  </button>
                                </td>
                                <td>
                                  <button
                                    className="btn"
                                    onClick={(e) => {
                                      deleteData(e, x.trainingDetailId);
                                    }}
                                  >
                                    {" "}
                                    <i className="fas fa-trash"></i>
                                  </button>
                                </td>

                                <td>
                                  <button
                                    className="btn"
                                    onClick={() => openModal(x)}
                                  >
                                    <i className="fas fa-eye"></i>
                                  </button>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                  {/* /.card-body */}
                  <div className="card-footer clearfix">
                    <Pagination
                      totalItems={data.length}
                      itemsPerPage={itemsPerPage}
                      onPageChange={paginate}
                      currentPage={currentPage}
                      setCurrentPage={setCurrentPage}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default TrainingDetailsList;
